import { useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import OnboardingCreateAccountRoute from './OnboardingCreateAccountRoute';
import OnboardingTokenGuard from './OnboardingTokenGuard';
import { initializeLogRocket } from '@/utils/logRocket';

import {
  CompleteProfilePage,
  TrainingMenuPage,
  TrainingSectionPage,
  RegistrationPage,
  PendingPage,
} from '../features/onboarding';

const OnboardingRoutes = () => {
  useEffect(() => {
    initializeLogRocket();
  }, []);

  return (
    <Routes>
      <Route index element={<OnboardingCreateAccountRoute />} />
      <Route element={<OnboardingTokenGuard />}>
        <Route path="complete-profile" element={<CompleteProfilePage />} />
        <Route path="training" element={<TrainingMenuPage />} />
        <Route path="training/section/:id" element={<TrainingSectionPage />} />
        <Route path="registration" element={<RegistrationPage />} />
        <Route path="pending" element={<PendingPage />} />
        <Route path="*" element={<Navigate to="/onboarding" replace />} />
      </Route>
    </Routes>
  );
};

export default OnboardingRoutes;
